import { render, staticRenderFns } from "./GroupProductField.vue?vue&type=template&id=81f46634&"
import script from "./GroupProductField.vue?vue&type=script&lang=js&"
export * from "./GroupProductField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports